import React from 'react';
import LegalLayout from '@/components/LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" testId="privacy-page">
      <p>
        BeautyMateUK is the controller of personal data described here. This
        notice explains what we collect, why, and your rights under UK GDPR.
      </p>
      <h2>1. What we collect</h2>
      <ul>
        <li>Account: name, email, phone number, password (stored hashed).</li>
        <li>Customer: default address and postcode for service delivery.</li>
        <li>Partner: business name, base postcode, ID/insurance documents, qualifications.</li>
        <li>Bookings: service, address, scheduled time, price, notes.</li>
        <li>Payments: handled by Stripe; we do not store card details.</li>
        <li>Technical: cookies (HttpOnly session cookie), basic device/log data.</li>
      </ul>

      <h2>2. Why we use it</h2>
      <ul>
        <li>Provide and operate the Platform.</li>
        <li>Verify partner identity, qualifications and right to work.</li>
        <li>Match Customers with Partners within 5 km.</li>
        <li>Process payments and pay Partner payouts.</li>
        <li>Comply with legal obligations (records, fraud prevention).</li>
      </ul>

      <h2>3. Sharing</h2>
      <p>
        We share booking details with the assigned Partner so they can deliver
        the service. Address and phone are only shared after the Partner accepts.
        Payment data is processed by Stripe Inc. We do not sell personal data.
      </p>

      <h2>4. Retention</h2>
      <p>
        Personal data is retained while your account is active and for a
        reasonable period afterwards to satisfy legal and accounting duties.
      </p>

      <h2>5. Your rights</h2>
      <p>
        Under UK GDPR you may access, correct, port, restrict or delete your
        data. To exercise these rights email
        <a href="mailto:privacy@beautymateuk.com"> privacy@beautymateuk.com</a>.
      </p>

      <h2>6. Cookies</h2>
      <p>
        We use a single HttpOnly session cookie (<code>bm_session</code>) to keep
        you signed in. No third-party advertising cookies are used.
      </p>

      <h2>7. Complaints</h2>
      <p>
        You can complain to the UK Information Commissioner's Office (ICO) at
        ico.org.uk.
      </p>
    </LegalLayout>
  );
}
